import script from "./RecommendedReadsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendedReadsSection.vue?vue&type=script&setup=true&lang=js"

import "./RecommendedReadsSection.vue?vue&type=style&index=0&id=3514c632&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3514c632"]])

export default __exports__